/*
  Dasom Essence - quantity-tier selector for single-product pages.
  Buy 1 = regular, 2+ of the same product = 10% off, 3+ = 25% off.
  The discounts are REAL Shopify automatic discounts (12 of them, per product x tier,
  created 2026-07-29) - this widget only DISPLAYS the ladder and sets the quantity;
  checkout math is enforced server-side by Shopify, so the UI can never overpromise.

  Inserts above the Add-to-Cart button on the six single-product pages. Selecting a
  tier sets the product form's quantity input. Dual-currency display follows the
  storefront's region rules (US visitors see US$ first).
*/
(function () {
  'use strict';
  var TIERS = [
    { qty: 1, pct: 0 },
    { qty: 2, pct: 10 },
    { qty: 3, pct: 25 }
  ];
  var HANDLES = {
    'glow-wash-brightening-foam-cleanser': 1, 'glowtone-synergy-toner': 1,
    'glow-b20-brightening-concentrate': 1, 'lume-lift-serum': 1,
    'luxcell-revive-cream': 1, 'viva-glow-brightening-cream': 1
  };
  var m = location.pathname.match(/\/products\/([a-z0-9-]+)/);
  var handle = m && m[1];
  if (!handle || !HANDLES[handle]) return;

  var RATE = parseFloat(window.DASOM_USD_RATE) || 0.73;
  function dzUS() {
    try { var r = localStorage.getItem('dz_region'); if (r === 'US' || r === 'CA') return r === 'US'; } catch (e) {}
    try {
      var tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
      return tz === 'Pacific/Honolulu' || /^America\/(New_York|Chicago|Denver|Phoenix|Los_Angeles|Anchorage|Detroit|Boise|Juneau|Sitka|Nome|Menominee|Metlakatla|Yakutat|Adak|Indiana\/|Kentucky\/|North_Dakota\/)/.test(tz);
    } catch (e) { return false; }
  }
  function fmt(cadCents) {
    var cad = cadCents / 100;
    var ca = 'CA$' + (cad % 1 ? cad.toFixed(2) : cad.toLocaleString('en-CA'));
    var us = 'US$' + Math.round(cad * RATE).toLocaleString('en-US');
    return dzUS()
      ? us + ' <span class="dqt-sub">/ ' + ca + '</span>'
      : ca + ' <span class="dqt-sub">/ ' + us + '</span>';
  }

  // Primary-currency-only formatter for the struck-through regular price, so the
  // crossout stays compact next to the dual-currency discounted price.
  function fmtWas(cadCents) {
    var cad = cadCents / 100;
    var ca = 'CA$' + (cad % 1 ? cad.toFixed(2) : cad.toLocaleString('en-CA'));
    var us = 'US$' + Math.round(cad * RATE).toLocaleString('en-US');
    return dzUS() ? us : ca;
  }

  var CSS =
    '.dqt{margin:14px 0 6px;border:1px solid rgba(43,37,48,.14);border-radius:14px;padding:14px 14px 10px;font-family:inherit}' +
    '.dqt-h{font-size:.68rem;letter-spacing:.18em;text-transform:uppercase;font-weight:600;color:#9A7E3C;margin:0 0 10px;text-align:center}' +
    '.dqt-row{display:flex;gap:8px}' +
    '.dqt-opt{flex:1;border:1px solid rgba(43,37,48,.16);border-radius:11px;padding:10px 6px;text-align:center;cursor:pointer;background:#fff;transition:border-color .2s,box-shadow .2s;position:relative}' +
    '.dqt-opt:hover{border-color:#9A7E3C}' +
    '.dqt-opt.on{border-color:#9A7E3C;box-shadow:0 0 0 1px #9A7E3C}' +
    '.dqt-q{font-weight:700;font-size:1.02rem;color:#2B2530}' +
    '.dqt-save{display:inline-block;margin-top:3px;font-size:.66rem;font-weight:700;letter-spacing:.06em;color:#fff;background:#9A7E3C;border-radius:100px;padding:2px 8px;text-transform:uppercase}' +
    '.dqt-save.zero{background:transparent;color:rgba(43,37,48,.45)}' +
    '.dqt-p{margin-top:6px;font-size:.8rem;color:#2B2530}' +
    '.dqt-was{display:block;font-size:.7rem;color:rgba(43,37,48,.5);text-decoration:line-through;margin-bottom:1px}' +
    '.dqt-off{display:block;font-size:.68rem;font-weight:700;color:#9A7E3C;margin-top:2px}' +
    '.dqt-each{display:block;font-size:.68rem;color:rgba(43,37,48,.55);margin-top:1px}' +
    '.dqt-sub{opacity:.6;font-size:.88em;white-space:nowrap}' +
    '.dqt-note{margin:9px 0 0;font-size:.68rem;color:rgba(43,37,48,.55);text-align:center}';

  function build(priceCents, form) {
    // Quantity control: use the page's quantity input when the theme shows one; otherwise
    // drop a hidden quantity field into the buy form (Shopify's /cart/add honors it).
    var qtyInput = form.querySelector('input[name="quantity"]') ||
      document.querySelector('.product-form__input--quantity input[name="quantity"], quantity-input input[name="quantity"]');
    if (!qtyInput) {
      qtyInput = document.createElement('input');
      qtyInput.type = 'hidden';
      qtyInput.name = 'quantity';
      qtyInput.value = '1';
      form.appendChild(qtyInput);
    }
    var anchor = form.querySelector('.product-form__buttons, button[name="add"], [type="submit"]');
    if (!anchor) return;
    var host = anchor.closest('.product-form__buttons') || anchor;

    var style = document.createElement('style');
    style.textContent = CSS;
    document.head.appendChild(style);

    var box = document.createElement('div');
    box.className = 'dqt';
    box.innerHTML = '<p class="dqt-h">Buy more, save more</p><div class="dqt-row"></div>' +
      '<p class="dqt-note">Savings apply automatically in your cart.</p>';
    var row = box.querySelector('.dqt-row');

    TIERS.forEach(function (t, i) {
      var each = Math.round(priceCents * (100 - t.pct) / 100);
      var opt = document.createElement('button');
      opt.type = 'button';
      opt.className = 'dqt-opt' + (i === 0 ? ' on' : '');
      opt.setAttribute('aria-pressed', i === 0 ? 'true' : 'false');
      opt.innerHTML =
        '<span class="dqt-q">' + t.qty + '</span>' +
        '<span class="dqt-save' + (t.pct ? '' : ' zero') + '">' + (t.pct ? 'save ' + t.pct + '%' : 'regular') + '</span>' +
        '<span class="dqt-p">' +
          (t.pct ? '<span class="dqt-was">' + fmtWas(priceCents * t.qty) + '</span>' : '') +
          fmt(each * t.qty) +
          (t.qty > 1 ? '<span class="dqt-each">' + fmt(each) + ' each</span>' : '') +
          (t.pct ? '<span class="dqt-off">You save ' + fmtWas(priceCents * t.qty - each * t.qty) + ' (' + t.pct + '%)</span>' : '') +
        '</span>';
      opt.addEventListener('click', function () {
        row.querySelectorAll('.dqt-opt').forEach(function (o) { o.classList.remove('on'); o.setAttribute('aria-pressed', 'false'); });
        opt.classList.add('on');
        opt.setAttribute('aria-pressed', 'true');
        if (qtyInput) {
          qtyInput.value = t.qty;
          qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
      row.appendChild(opt);
    });
    host.parentElement.insertBefore(box, host);
  }

  function init() {
    // Several forms post to /cart/add (Dawn adds a hidden "installment" form first);
    // the real buy form is the one holding the Add-to-Cart button.
    var form = Array.prototype.find.call(
      document.querySelectorAll('form[action*="/cart/add"]'),
      function (f) { return f.querySelector('button[name="add"], [type="submit"]'); });
    if (!form) return;
    // Price source 1: the page's own analytics meta (synchronous, no request).
    try {
      var mp = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product;
      var mv = mp && mp.variants && mp.variants[0];
      if (mv && mv.price) { build(mv.price, form); return; }
    } catch (e) {}
    // Fallback: product JSON endpoint.
    fetch('/products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (p) {
      var v = (p.variants || [])[0];
      if (v) build(v.price, form);
    }).catch(function () {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
